import { useArticleSearch } from "@/features/search/hooks/useArticleSearch";
import SearchBar from "@/features/search/components/SearchBar";
import SearchResults from "@/features/search/components/SearchResults";
import RelevanceFilter from "@/features/search/components/RelevanceFilter";
import { Article } from "@/features/search/types/search";
import { TrendingView } from "@/features/trending/components/TrendingView";
import { useSearchFilters } from "@/features/search/hooks/useSearchFilters";
import { SearchMode } from "@/features/search/types/search";
import Gist from "@/features/search/components/Gist";
import { useCliffNote } from "@/features/trending/hooks/useCliffNote";
export const ArticleSearch = () => {
  const {
    searchResults,
    searchError,
    isSearching,
    query,
    handleChange,
    handleSubmit,
    handleKeyDown,
  } = useArticleSearch();

  const {
    relevanceThreshold,
    MATCH_COUNT,
    ACTIVE_MODE,
    daysAgo,
    handleRelevanceChange,
  } = useSearchFilters();

  const { createCliffNote, isGeneratingCliffNote } = useCliffNote();

  const formatResults = (items: Article[]) => {
    return items
      .filter((result) => (result.relevance_score || 0) >= relevanceThreshold)
      .map((result) => ({
        title: result.title,
        summary: result.summary,
        date: result.publish_date,
        source: result.author,
        relevance: result.relevance_score,
        similarity: result.similarity_score,
        url: result.link,
        author: result.author,
        publish_date: result.publish_date,
        tags: result.tags,
      }));
  };

  return (
    <div className="space-y-4">
      {searchError && (
        <div className="text-red-500 p-2 rounded bg-red-50">{searchError}</div>
      )}

      <SearchBar
        query={query}
        handleChange={handleChange}
        handleSubmit={(e) =>
          handleSubmit(
            e as React.FormEvent<HTMLFormElement>,
            ACTIVE_MODE as SearchMode,
            daysAgo,
            MATCH_COUNT
          )
        }
        handleKeyDown={(e) =>
          handleKeyDown(e, ACTIVE_MODE as SearchMode, daysAgo, MATCH_COUNT)
        }
      />

      {searchResults.length > 0 ? (
        <>
          <RelevanceFilter
            relevanceThreshold={relevanceThreshold}
            onRelevanceChange={handleRelevanceChange}
          />

          <Gist
            results={searchResults}
            query={query}
            createCliffNote={createCliffNote}
            isGeneratingCliffNote={isGeneratingCliffNote}
            isSearching={isSearching}
          />

          <SearchResults
            results={formatResults(searchResults)}
            isLoading={isSearching}
          />
        </>
      ) : (
        <>
          <TrendingView key="trending" />
          <SearchResults
            results={formatResults(searchResults)}
            isLoading={isSearching}
          />
        </>
      )}
    </div>
  );
};
